<template>
    <div class="fSize">
        <!--<p>个人信息页面其他信息</p>-->
        <div class="title">
            <van-image round fit="cover" width="2rem" height="2rem" :src="user.headimgurl"/>
            <van-row class="row">
                <van-col span="24">{{user.nickname ? user.nickname : "一直有理想的青蛙"}}</van-col>
            </van-row>
        </div>
        <van-cell v-for="item in route" :key="item.name" class="newCell font28" center is-link :title="item.name"
                  :icon="item.icon" @click="goOtherPage(item.path)"/>
    </div>
</template>
<script>
    import {Cell, CellGroup, Image as VanImage, Col, Row} from 'vant';

    export default {
        components: {
            [Cell.name]: Cell,
            [CellGroup.name]: CellGroup,
            [VanImage.name]: VanImage,
            [Col.name]: Col,
            [Row.name]: Row
        },
        data() {
            return {
                route: [
                    {name: "用户管理", path: "/user", icon: "contact"},
                    {name: "报告查询", path: "/report", icon: "description"},
                    {name: "订单管理", path: "/order", icon: "records"},
                    {name: "网上购卡", path: "/buyCard", icon: "other-pay"},
                    {name: "网上预约", path: "/makeAnAppointment", icon: "todo-list-o"}
                ],
                user: sessionStorage.getItem('userInfo') ? JSON.parse(sessionStorage.getItem('userInfo')) : {}
            }
        },
        created() {
            const that = this;
            //---控制头尾显示与隐藏----
            //that.$emit('footer', true);
        },
        methods: {
            //去其他页面
            goOtherPage(s) {
                const that = this;
                that.$router.push({path: s})
            }
        }
    }
</script>
<style scoped lang="scss">
    .title {
        height: 3rem;
        padding-top: 0.5rem;
        text-align: center;

        .row {
            margin-top: 0.2rem;
        }
    }

    .newCell {
        height: 1rem;
    }
</style>
